import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "react-router-dom";
import DesktopMenu from "./nav/DesktopMenu";
import MobileMenu from "./nav/MobileMenu";
import { useIsMobile } from "@/hooks/use-mobile";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = useIsMobile();

  return (
    <nav className="fixed w-full z-50">
      <div className="mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="bg-white/90 backdrop-blur-sm shadow-lg rounded-xl px-6 py-3">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <Link to="/" className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-primary rounded-lg"></div>
              <span className="text-xl font-bold text-primary-dark">Kover King</span>
            </Link>
            
            {/* Desktop Menu */}
            <DesktopMenu />

            {/* Mobile Menu Button */}
            <div className={isMobile ? "flex items-center" : "hidden"}>
              <button
                onClick={() => setIsOpen(!isOpen)}
                className="text-neutral hover:text-primary transition"
              >
                {isOpen ? <X size={24} /> : <Menu size={24} />}
              </button>
            </div>
          </div>

          {/* Mobile Menu */}
          <MobileMenu isOpen={isOpen} />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;